<template>

<div v-if='isReady'>

    <div class="row">
        <div class="col-12">
            <div class="fieldset">
                <h3 class="fieldset-title">Основни данни</h3> 
                <div class='text-center' v-if='!isNew'>
                    <a :href="'/projects/' + model.id + '/record'">Досие на проекта</a>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for='name'>Име на проекта</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-folder"></span>
                                    </div>
                                </div>                            
                                <input class='form-control input-lg' id='name' v-model='model.name'>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for='sub_type_id'>Вид обект</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-home"></span>
                                    </div>
                                </div>

                                <select class='custom-select input-lg' id='sub_type_id' v-model='model.sub_type_id'>
                                    <optgroup v-for='t in types' :label='t.name'>
                                        <option v-for='st in t.sub_types' :value="st.id">{{ st.name }}</option>
                                    </optgroup>
                                </select>
                            </div>                            
                       </div>
                    </div>
                    <div class="col-md-6 col-12"> 
                        <div class="form-group">                    
                            <label for='quadrature_id'>Квадратура (в кв.м.)</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-maximize"></span>
                                    </div>
                                </div>

                                <input class='form-control input-lg' 
                                       id='quadrature' type='number' 
                                       v-model.number='model.quadrature'>

                                <select class='custom-select input-lg d-none' id='quadrature_id' v-model='model.quadrature_id' disabled>
                                    <option v-for='q in quads' :value="q.id">{{ q.name }}</option>
                                </select>

                            </div>                            
                        </div>
                    </div>
                </div>

                <hr class="mt-4 mb-4 ml-1 mr-1" />

                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for='city'>Град</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-flag"></span>
                                    </div>
                                </div>                            
                                <input class='form-control input-lg' id='city' v-model.trim='model.city'>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for='address'>Адрес</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-map-pin"></span>
                                    </div>
                                </div>
                                <input class='form-control input-lg' id='address' v-model.trim='model.address'>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label for='desc'>Описание</label>
                            <textarea class='form-control summernote' id='desc' v-model.trim='model.desc'></textarea> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="fieldset border-0 pl-0 pr-0">
                <h3 class="fieldset-title">Бюджети и срокове</h3> 

                <div class="row pl-3 pr-3">

                    <!-- Box 1 -->
                    <div class="col-md-6 fieldset box-pr-settings-1 pl-4 pr-4 mb-0">                        
                        <h5 class="mb-3 text-lg-center">Какво е най-важно за теб?</h5> 
                        <div class="row">
                            <div v-if='isReady' class='col-12'>
                                <project-criteria ref='crt'></project-criteria>
                            </div>
                        </div>                      
                    </div>

                    <!-- Box 2 -->
                    <div class="col-md-6 fieldset pl-4 pr-4 mb-0">
                        <h5 class="mb-3 text-lg-center">Задай твоя бюджет и срок</h5>

                        <div v-if='!model.sub_type_id || !model.quadrature_id' class="text-red mb-3 text-lg-center">
                            Моля, избери вид обект и квадратура, за да видиш приблизителните цени за твоя обект.
                        </div>

                        <div v-else class="text-orange mb-3 text-lg-center">
                            Приблизителните цена и срок се изчисляват автоматично на база на параметри отговарящи на пазара за типа и квадратурата на твоя обект. <br>
                            Можеш да зададеш бюджет и срок с максимум  {{ displacement }}% по-малък от посочените.
                        </div>           
                        
                        <div>
                            <div class="form-group mb-0">
                                <label for='budget' class="ml-1">Твоят бюджет (в лв.):</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="icon icon-wallet"></span>
                                        </div>
                                    </div>
                                    <input class='form-control input-lg' 
                                        type='number' 
                                        id='budget' 
                                        v-model.number='model.budget' 
                                        placeholder="Твоят бюджет" 
                                        :disabled='!model.sub_type_id || !model.quadrature_id'>
                                </div>
                            </div>

                            <div v-if='!costOK' class='alert alert-danger text-tiny pt-2 pb-2 mt-2'>
                                <span class="icon icon-alert-octagon"></span>
                                Моля, въведи цена, която е не по-малка от приблизителната с {{ displacement }}%.
                            </div>
                        </div>
                       
                        <div class="mt-4">
                            <div class="form-group mb-0">
                                <label for='term' class="ml-1">Срок на проекта (в дни)</label>

                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="icon icon-calendar"></span>
                                        </div>
                                    </div>
                                    <input class='form-control input-lg' type='number' id='term' 
                                        v-model.number='model.term' 
                                        placeholder="Максимален брой дни за завършване на проекта" 
                                        :disabled='!model.sub_type_id || !model.quadrature_id'>
                                </div>
                            </div>
                            
                            <div v-if='!termOK' class='alert alert-danger text-tiny pt-2 pb-2 mt-2'>
                                <span class="icon icon-alert-octagon"></span>
                                Моля, въведи срок който е не по-малък от приблизителния с {{ displacement }}%.
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="alert alert-info text-tiny mt-3 justify-content-start">
                                <span class="icon icon-info3"></span>
                                <div>
                                    <h6>Параметри за изработка на Идеен проект:</h6>
                                    <div>
                                        <small>Цена:</small>
                                        <strong  v-if='model.sub_type_id && model.quadrature_id' class="text-orange"> {{ getCostIP }} лв.</strong> 
                                        <strong v-else class="text-orange">... лв. без ДДС</strong>
                                    </div>
                                    <div>
                                        <small>Приблизителeн срок:</small>
                                        <strong v-if='model.sub_type_id && model.quadrature_id' class="text-orange"> {{ getTimeIP }} дни.</strong>  
                                        <strong v-else class="text-orange">... дни.</strong>
                                    </div>
                                    <a href="/blog/kak-raboti/konkurs-ideen-proekt" class="d-block mt-2">
                                        Какво е Идеен Проект?
                                    </a>
                                </div>
                            </div>

                            <div class="alert alert-info text-tiny mt-3 justify-content-start">
                                <span class="icon icon-info3"></span>
                                <div>
                                    <h6>Параметри за изработка на целия проект:</h6>
                                    <div>
                                        <small>Приблизителна цена:</small>
                                        <strong v-if='model.sub_type_id && model.quadrature_id' class="text-orange"> {{ getCost }} лв.</strong> 
                                        <strong v-else class="text-orange">... лв.</strong>
                                    </div>
                                    <div>
                                        <small>Приблизителeн срок:</small>
                                        <strong v-if='model.sub_type_id && model.quadrature_id' class="text-orange"> {{ getTime }} дни.</strong>
                                        <strong v-else class="text-orange">... дни.</strong>
                                    </div>
                                    <a href="/blog/kak-raboti/izbirame-videa" class="d-block mt-2">
                                        Какво включва работата по проекта?
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Box 3 -->
                <div class="row pl-3 pr-3">
                    <div class="col-md-12 fieldset pl-4 pr-4 bg-light border-top-0 mb-0">
                        <h4 class="mb-4 text-center">Крайни параметри</h4>
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-4 col-md-6 d-flex item-result justify-content-lg-center mb-3 mb-lg-0">
                                <span class="icon icon-wallet"></span>
                                <div>
                                    <h6>Бюджет на проекта</h6>
                                    <h4 v-if='model.sub_type_id && model.quadrature_id'>{{ model.budget }} лв.</h4>
                                    <h4 v-else>--</h4>
                                </div>
                            </div> 

                            <div class="col-lg-4 col-md-6 d-flex item-result justify-content-lg-center mb-3 mb-lg-0">
                                <span class="icon icon-clock"></span>
                                <div>
                                    <h6>Срок на проекта</h6>
                                    <h4 v-if='model.sub_type_id && model.quadrature_id'>{{ model.term }} дни.</h4>
                                    <h4 v-else>--</h4>
                                </div>
                            </div>

                            <div class="col-lg-4 d-flex item-result justify-content-lg-center">
                                <span class="icon icon-star-empty"></span>
                                <div>
                                    <h6>Приоритети на проекта</h6>
                                    <span class="d-block">
                                        <strong>{{ criteria ? criteria.cost : "..." }}% </strong>
                                        Бюджетно решение
                                    </span>
                                    <span class="d-block">
                                        <strong>{{ criteria ? criteria.time : "..." }}% </strong>
                                        Срок на проекта
                                    </span>
                                    <span class="d-block">
                                        <strong>{{ criteria ? criteria.rating : "..." }}% </strong>
                                        Висок рейтинг
                                    </span>
                                </div>
                            </div>                          
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div> 
    
    <div class="row">
        <div class="col-12 ">
            <div class="fieldset">
                <h3 class="fieldset-title mb-2">Предпочитани стилове</h3> 

                <div class="row">
                    <div class="col-12">
                        <p class="text-center mb-5">
                            Ако не сте запознати със стиловете в интериора и имате нужда по повече информация какво представляват те, 
                            кой отговаря най-много на Вашите дух и персоналност, то може да
                            <a href="/blog/kak-raboti/stilove-v-interiora" target="_blank">
                                <strong>научите повече ТУК</strong> 
                                <span class="icon icon-chevrons-right"></span> 
                            </a>
                        </p>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-md-6" v-for='s in styles'>
                        <div class="custom-control custom-checkbox mb-2">
                            <input type='checkbox' 
                                :id='"pst-" + s.id' 
                                class="custom-control-input" 
                                v-model='projectStyles[ s.id ]'>

                            <label :for='"pst-" + s.id' class="custom-control-label">
                                {{ s.name }}
                            </label>
                        </div>
                    </div>
                </div>                            
                    
            </div>
        </div>
    </div>

    <div class="row">
        <div class='col-12 text-center mb-4'>
            <form-validator ref='validator' :fields='validatorFields'></form-validator>

            <button @click='save' class='btn btn-success btn-lg' :disabled='$store.state.isLoading'>
                <span class="icon icon-save"></span>
                {{ isNew ? 'Създай проект' : 'Запази' }}
            </button>
        </div>
    </div>

</div>
 

</template>

<script>
    export default {

        mounted() {
            this.getData();

            bus.$on('has-files', ( f ) => {

                if( f === false ) {
                
                    this.hasFiles = false;
                
                } else {

                    this.hasFiles = true;
                }

            })
        },

        created() {

            if( typeof this.pid == 'undefined' ) {
            
                this.isNew = true;
                this.model = Object.assign({}, this.mdl );
            
            } else {
                
                this.isNew = false;
               
            }

        },

        props : ['pid'],

        data() {
            return {
                isReady     : false,
                isNew       : true,
                types       : [],
                sub_types   : [],
                quads       : [],
                styles      : [],

                hasFiles    : false,

                displacement : 10, //% displacement of days/cost

                projectStyles : {},

                model : false,

                costOK : true,
                termOK : true,

                mdl : {
                    name    : '',
                    quadrature    : 0,
                    desc    : '',
                    address : '',
                    term    : null,
                    budget  : null,
                    city    : null,
                    sub_type_id     : null,
                    quadrature_id   : null,
                },
                
                criteria : null,

                //Validate Project info
                validatorFields : [
                    { 
                        selector  : "#name",
                        minLength : 2,
                        customErr : 'Моля, въведи име на проекта'
                    },
                    { 
                        selector  : "#address",
                        minLength : 2,
                        customErr : 'Моля, въведи адрес'
                    },
                    { 
                        selector  : "#sub_type_id",
                        customErr : 'Моля, избери вид обект'
                    },
                    // { 
                    //     selector  : "#quadrature_id",
                    //     customErr : 'Моля, избери квадратура'
                    // },
                    { 
                        selector  : "#quadrature",
                        customErr : 'Моля, въведете квадратура',
                        min       : 1,
                        max       : 10000
                    },
                    { 
                        selector  : "#budget",
                        customErr : 'Моля, въведи бюджет.'
                    },
                    { 
                        selector  : "#term",
                        customErr : 'Моля, въведи срок за изпълнение (в дни).'
                    }
                ]
            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('prj:ga', {}, (r) => {

                    if( me.isNew ) {
                       
                        me.isReady = true;
                        me.initSummernote("#desc");

                    } else {

                        me.findProject();

                    }

                    if( r.status == 'success' ) {
                        me.quads = r.data.q;
                        me.styles = r.data.s;
                        me.types = r.data.t;
                        me.coefs = r.data.c;

                        for( var i in me.styles ) {
                            me.projectStyles[ me.styles[i].id ] = 0;
                        }

                        for( var i in me.types ) {

                            for( var j in me.types[i].sub_types ) {
                                me.sub_types.push( me.types[i].sub_types[j] );
                            }

                        }
                    }

                })
            },

            findProject() {
                var me = this;

                me.ajax.call('prj:gt', { p : this.pid }, (r) => {

                    if( r.status == 'success' ) {
                        me.model 	  = r.data.p;

                        if( r.data.c ) {

                            me.criteria = {
                                cost : r.data.c.cost,
                                time : r.data.c.time,
                                rating : r.data.c.rating,
                            };
                            
                        }

                        for( var i in r.data.s ) {
                            me.projectStyles[ r.data.s[i] ] = true;
                        }
                    }

                    me.isReady = true;
                    me.initSummernote("#desc");
                })
            },

            save() {

                this.model.desc = $('#desc').summernote('code');

                var me = this;

                if( !this.costOK || !this.termOK ) {
                    $.notify("Моля, попълни коректно данните за срок/бюджет","warning");

                    return;
                }

                this.$refs.validator.validate({
                    resolve() {

                        me.isLoading = true;

                        if( me.$refs.crt.ptsLeft > 0 ) {
                        	
                        	$.notify("Моля, разпредели останалите точки от критерия за оценяване","warning");
                        	
                            me.navigate('#prj-crt');

                        	return false;

                        }

                        me.ajax.call('prj:cr', { mdl : me.model, s : me.projectStyles, c : me.criteria } , (r) => {
                            me.isLoading = false;

                            if( r.status == 'success' ) {

                                if( typeof me.$parent.onSaveSuccess == 'function' ) {
                                    me.$parent.onSaveSuccess( r.data );
                                }

                                if( !me.isNew ) {
                                    
                                    me.notify('save-success');

                                } else {
                                    
                                    $.notify('Вашият проект беше създаден успешно','success');
                                }

                                setTimeout( () => {
                                    //Project does not have files.
                                    if( !me.hasFiles ) {
                                        
                                        alert('Моля не забравяте да качите нужните файлове към проекта');

                                        me.navigate('.file-grid-row', 300);
                                    }
                                    
                                }, 1000);


                            }

                        })

                    }
                })

            },

        },

        computed : {

            getCost() {
                var A = this.findKey( this.sub_types, 'id', this.model.sub_type_id ), 
                    B = this.findKey( this.quads, 'id', this.model.quadrature_id );

                return this._cf.cost(A,B,this.coefs,this.model.quadrature);
            },

            getCostIP() {
                var A = this.findKey( this.sub_types, 'id', this.model.sub_type_id ), 
                    B = this.findKey( this.quads, 'id', this.model.quadrature_id );

                return this._cf.costIP(A, B, this.coefs, false, this.model.quadrature);
            },

            getTime() {
                var A = this.findKey( this.sub_types, 'id', this.model.sub_type_id ), 
                    B = this.findKey( this.quads, 'id', this.model.quadrature_id );

                return parseInt( A.coef_time * B.coef_time * this.coefs.bt );
            },

            getTimeIP() {
                var A = this.findKey( this.sub_types, 'id', this.model.sub_type_id ), 
                    B = this.findKey( this.quads, 'id', this.model.quadrature_id );

                return parseInt( A.coef_time_ip * B.coef_time_ip * this.coefs.bti );
            },

        },

        watch : {
            
            'model.quadrature' : function( n, o ) {
                for( var i in this.quads ) {
                    if( n > this.quads[i].size_from && n <= this.quads[i].size_to ) {
                        this.model.quadrature_id = this.quads[i].id;
                        break;
                    }
                }
            },

            'model.budget' : _.debounce(function( n, o ) {

                if( typeof n == 'number' ) {

                    let d = parseInt( this.getCost * this.displacement / 100 ),
                        min = this.getCost - d,
                        max = this.getCost + d;

                    if( n > min ) { 

                        this.costOK = true;

                    } else {

                        this.costOK = false;

                    }

                    
                } else {

                    this.costOK = true;

                }

            }, 350),

            'model.term' : _.debounce(function( n, o ) {

                if( typeof n == 'number' ) {

                    let d = parseInt( this.getTime * this.displacement / 100 ),
                        min = this.getTime - d,
                        max = this.getTime + d;

                    if( n > min ) { 

                        this.termOK = true;

                    } else {

                        this.termOK = false;

                    }

                    
                } else {

                    this.termOK = true;

                }

            }, 350),
        },

        components : {
        	'project-criteria' : require( './ProjectCriteria.vue' ).default
        }


    }
</script>